export function getMediaVideoComponent() {
  return [
    "forbidden-to-move"
    /*{
    component: "media-loader",
    property: "mediaOptions"
  },*/
    /*  {
      component: "media-video",
      property: "distanceModel"
    }, {
      component: "media-video",
      property: "rolloffFactor"
    }, {
      component: "media-video",
      property: "refDistance"
    }, {
      component: "media-video",
      property: "maxDistance"
    }, {
      component: "media-video",
      property: "coneInnerAngle"
    }, {
      component: "media-video",
      property: "coneOuterAngle"
    }, {
      component: "media-video",
      property: "coneOuterGain"
    }*/
  ];
}
